import React from "react";
import Proptypes from "prop-types";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";

import { Image, RatingImage, Title, SubTitle, About, Container } from "./style";
import {
	STAR_RATE_FALSE,
	STAR_RATE_TRUE,
} from "@website-builder/utilities-index";

const RatingCard = ({ name, about, description, mentorImage, starRating }) => {
	let starRatingsArray = [];
	for (let i = 1; i <= 5; i++) {
		if (i <= parseInt(starRating)) {
			starRatingsArray.push(
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="1em"
					height="1em"
					viewBox="0 0 1024 1024"
				>
					<path
						d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5c-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1l-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2c17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9l183.7-179.1c5-4.9 8.3-11.3 9.3-18.3c2.7-17.5-9.5-33.7-27-36.3z"
						fill={STAR_RATE_TRUE}
					/>
				</svg>,
			);
		} else {
			starRatingsArray.push(
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="1em"
					height="1em"
					viewBox="0 0 1024 1024"
				>
					<path
						d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5c-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1l-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2c17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9l183.7-179.1c5-4.9 8.3-11.3 9.3-18.3c2.7-17.5-9.5-33.7-27-36.3z"
						fill={STAR_RATE_FALSE}
					/>
				</svg>,
			);
		}
	}

	return (
		<Container>
			<div className="mentor-image">
				{mentorImage && mentorImage.image && (
					<Image>
						<CloudinaryImage
							url={mentorImage?.image}
							quality="auto"
							lazyload
							fetchFormat="auto"
							sizes={{
								default: {
									height: 121,
								},
							}}
							alt={mentorImage?.avatar?.altTag || ""}
						/>
					</Image>
				)}
				<RatingImage>{starRatingsArray}</RatingImage>
				<div className="mentor-mobile">
					<Title>{name}</Title>
					<SubTitle>{about}</SubTitle>
				</div>
			</div>
			<div className="mentor-info">
				<About>{description}</About>
				<div className="mentor-dekstop">
					<Title>{name}</Title>
					<SubTitle>{about}</SubTitle>
				</div>
			</div>
		</Container>
	);
};

RatingCard.propTypes = {
	name: Proptypes.string,
	description: Proptypes.string,
	about: Proptypes.string,
	mentorImage: Proptypes.string,
	starRating: Proptypes.number,
};

RatingCard.defaultProps = {
	name: "",
	description: "",
	about: "",
	mentorImage: "",
	starRating: 5,
};

export default RatingCard;
